import { ErrorResponse, GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { UploadDetailesResponse } from '@gtpl/shared-models/hrms';

export class ApplicationExceptionHandler {
    static returnException(UploadDetailesResponse: UploadDetailesResponse, error: any): import("../../../../../shared-models/hrms/src").UploadDetailesResponse | PromiseLike<import("../../../../../shared-models/hrms/src").UploadDetailesResponse> {
        throw new Error('Method not implemented.');
    }
    constructor() {
        // do nothing
    }

    returnException<T extends GlobalResponseObject>(classType: new (status: boolean, intlCode: number, internalMessage: string, data?: any) => T, errorObj: any): T {
        let errorCode;
        let message;
        if (errorObj instanceof ErrorResponse) {
            errorCode = errorObj.intlCode;
            message = errorObj.message;
        } else if (errorObj instanceof Error) {
            errorCode = 0;
            message = errorObj.message;
        }
        const responseObj = new classType(false, errorCode, message);
        responseObj.status = false;
        responseObj.intlCode = errorCode;
        responseObj.internalMessage = message;
        return responseObj;
    }
}